/**
 * Voucher codes (the `discount` module) and automatic catalog price rules
 * (the `catalog_discount` module).
 */
export default {
    status: {
        active: 'Active',
        scheduled: 'Scheduled',
        expired: 'Expired',
        exhausted: 'Exhausted',
        disabled: 'Disabled',
    },
    shared: {
        enabled: 'Enabled',
        startsAt: 'Starts at',
        expiresAt: 'Expires at',
        expiresHint: 'Blank = never expires.',
        searchProducts: 'Search products by name or SKU…',
        percentOff: '{value}% off',
        amountOff: '{amount} off',
    },
    index: {
        title: 'Vouchers',
        intro: 'Voucher codes for {website}.',
        noWebsite: 'Select a website first to manage its discount codes.',
    },
    types: {
        percent: 'Percentage off',
        fixed: 'Fixed amount off',
        freeShipping: 'Free shipping',
        bogo: 'Buy X get Y (BOGO)',
    },
    list: {
        intro: 'Voucher / discount codes customers enter on the cart. All amounts in cents.',
        newCode: 'New code',
        empty: 'No discount codes yet. Create one to offer a voucher at checkout.',
        typeValue: 'Type / value',
        used: 'Used',
        freeShipping: 'Free shipping',
        bogo: 'Buy X get Y',
        confirmDelete: 'Delete discount code "{code}"? This cannot be undone.',
        deleted: 'Discount code deleted',
    },
    edit: {
        newTitle: 'New discount code',
        editTitle: 'Edit discount code',
        created: 'Discount code created',
        saved: 'Discount code saved',
        codePlaceholder: 'SUMMER10',
        codeHint: 'Shown to the customer. Stored upper-cased.',
        typeLocked: 'Type cannot change after creation.',
        percentOff: 'Percentage off',
        percentHint: 'Whole percent, e.g. 10 = 10% off the subtotal.',
        amountOff: 'Amount off (cents)',
        amountHint: "In the cart's currency, e.g. 500 = €5.00 off.",
        freeShippingNote: "Free-shipping codes waive the order's shipping cost. No value to set.",
        buyQty: 'Buy quantity (X)',
        getQty: 'Get quantity (Y)',
        rewardIsPercent: 'Reward is a percentage',
        rewardIsPercentHint: 'Off = the “get” units are free (100% off).',
        rewardPercent: 'Reward percentage off the “get” units',
        rewardPercentHint: '100 = the get units are free.',
        products: 'Qualifying products',
        productsHint: 'Leave products and categories empty to apply to the whole cart.',
        removeProduct: 'Remove product',
        categories: 'Qualifying categories',
        minOrder: 'Minimum order (cents)',
        minOrderHint: 'Cart subtotal required to redeem. 0 = no minimum.',
        maxRedemptions: 'Max redemptions',
        unlimited: 'Unlimited',
        maxRedemptionsHint: 'Total uses across all customers. Blank = unlimited.',
        startsHint: 'Blank = available immediately.',
        create: 'Create code',
        save: 'Save code',
    },
    catalog: {
        index: {
            title: 'Catalog discounts',
            intro: 'Automatic sale & volume pricing for {website}.',
            noWebsite: 'Select a website first to manage its catalog discounts.',
        },
        kinds: {
            sale: 'Sale (flat discount)',
            volume: 'Volume (quantity tiers)',
        },
        scopes: {
            product: 'Single product',
            category: 'Category',
        },
        saleAdjustments: {
            percent: 'Percentage off',
            fixed: 'Fixed amount off (cents)',
        },
        tierAdjustments: {
            percent: '% off',
            fixed: 'Amount off (cents)',
            absolute: 'Fixed unit price (cents)',
        },
        list: {
            intro: 'Automatic discounts on products/categories, no code needed. All amounts in cents.',
            newRule: 'New rule',
            empty: 'No price rules yet. Create a sale or volume-tier rule to discount catalog prices automatically.',
            kindValue: 'Kind / value',
            appliesTo: 'Applies to',
            tiers: 'no tiers | {n} tier | {n} tiers',
            confirmDelete: 'Delete price rule "{name}"? This cannot be undone.',
            deleted: 'Price rule deleted',
        },
        edit: {
            newTitle: 'New price rule',
            editTitle: 'Edit price rule',
            created: 'Price rule created',
            saved: 'Price rule saved',
            namePlaceholder: 'Summer sale – shoes',
            nameHint: 'Internal label shown in this list.',
            kind: 'Kind',
            kindLocked: 'Kind cannot change after creation.',
            scope: 'Scope',
            scopeHint: 'Product-scoped rules win over category-scoped ones.',
            priority: 'Priority',
            priorityHint: 'Higher wins when two same-scope rules match.',
            product: 'Product',
            clearProduct: 'Clear product',
            category: 'Category',
            discountType: 'Discount type',
            percentOff: 'Percentage off',
            percentHint: 'Whole percent, e.g. 10 = 10% off the price.',
            amountOff: 'Amount off (cents)',
            amountHint: 'e.g. 500 = €5.00 off each unit.',
            tiers: 'Quantity tiers',
            tiersHint: 'At or above the quantity, every unit is repriced to that tier.',
            addTier: 'Add tier',
            minQty: 'Min qty',
            tierPercent: '% off',
            tierCents: 'Cents',
            startsHint: 'Blank = active immediately.',
            create: 'Create rule',
            save: 'Save rule',
        },
    },
};
